import React from "react";
import Tab from "./Tab";
import { Tabs } from "./styled";

class TabList extends React.Component {
  handleClick = tab => {
    this.props.changeTab(tab);
  };
  render() {
    return (
      <Tabs className="tabs is-toggle is-centered is-fullwidth is-medium">
        <ul>
          {this.props.tabList.map(tab => (
            <Tab
              key={tab.id}
              handleClick={this.handleClick.bind(this, tab)}
              name={tab.abbr}
              isActive={this.props.currentTab === tab.id}
            />
          ))}
        </ul>
      </Tabs>
    );
  }
}

export default TabList;



// WEBPACK FOOTER //
// ./src/pages/Materials/MaterialComponent/TabList.js